import { Calendar } from "primereact/calendar"
import { useTranslation } from "react-i18next";
import { ResponsiveContainer, CartesianGrid, XAxis, YAxis, Legend, AreaChart, Area, Tooltip, LineChart, Line, ComposedChart } from "recharts"


export const TempHistoryGraph = ({
    tempsData,
    date,
    onDateChange = (e) => { }
}) => {

    const [t] = useTranslation(["global", "health"]);

    // Funzioni per ottenere inizio e fine della giornata
    const getStartOfDay = () => Math.floor(date.setHours(0, 0, 0, 0));
    const getEndOfDay = () => Math.floor(date.setHours(23, 59, 59, 999));

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip bg-dark card">
                    <div className="card-header">Polso <b>{payload[0].value}</b> °C</div>
                    <div className="card-body text-muted"><small>Amb. {payload[1].value} °C</small></div>
                    <div className="card-footer"> {new Date(label * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</div>

                </div>
            );
        }

        return null;
    };


    return <div className="card mt-2 bg-black bg-opacity-10 text-white p-4">
        <div className="d-flex  justify-content-between mb-3">
            <div>
                <h4><i className="fa-solid fa-temperature-three-quarters text-muted"></i> {t("health:entity.data.temperature")}</h4>
                <span className="small text-muted">{tempsData.length} {t("health:unit.measurements", { count: tempsData.length })}</span>
            </div>
            <div>
                <Calendar value={date} onChange={(e) => onDateChange(e.value)} dateFormat="dd/mm/yy" />
            </div>
        </div>

        {
            tempsData?.length > 0 ?
                <ResponsiveContainer width="100%" height={400}>
                    <ComposedChart data={tempsData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                        <CartesianGrid strokeDasharray="3 3" opacity={0.5}/>
                        <XAxis
                            dataKey="timestamp"

                            type="number"
                            domain={[getStartOfDay() / 1000, getEndOfDay() / 1000]}
                            tickFormatter={(tick) =>
                                new Date(tick * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })
                            }
                            ticks={[(getStartOfDay() / 1000, getStartOfDay() / 1000) + 21600, (+getStartOfDay() / 1000) + 43200, (+getStartOfDay() / 1000) + 64800, getEndOfDay() / 1000]}
                            scale="time"
                        />
                        <YAxis
                            dataKey="wrist"
                            type="number"
                            scale="linear"
                            domain={[20, 40]}
                        />
                        <Tooltip content={CustomTooltip} />
                        <Legend />
                        <Line type="monotone" dataKey="wrist" name={`${t("health:entity.data.wrist_temp")} °C`} fill="rgb(250, 250, 250)" stroke="rgb(250, 250, 250)" strokeWidth={2} />
                        <Area type="monotone" opacity={0.25} dataKey="ambient" name={`${t("health:entity.data.amb_temp")} °C`} fill="rgb(41, 221, 194)" stroke="rgb(41, 221, 194)" strokeWidth={2} />
                    </ComposedChart>
                </ResponsiveContainer>
                : <h3 className="text-muted">{t("health:helper.no_data")}</h3>
        }
    </div>
}